import type { FC, ReactNode } from "react";
import { Flex, Spacing, Text } from "@huub-web/ui";

import {
  cardStyle,
  imageStyle,
  containerStyle,
  contentStyle,
} from "./ObvionBanner.css";

type ObvionBannerProps = {
  children?: ReactNode;
  /**
   * Banner title displayed in the content card
   */
  title: string;
  /**
   * Banner description displayed below the title
   */
  description: string;
  /**
   * URL of the background image
   */
  imageSrc: string;
};

/**
 * Full-width banner for Obvion theme slot overrides.
 * Image fills the container as background; content card sits bottom-right.
 */
export const ObvionBanner: FC<ObvionBannerProps> = ({
  children,
  title,
  description,
  imageSrc,
}) => {
  return (
    <>
      <Spacing height="m" />
      <Flex className={containerStyle}>
        <img className={imageStyle} src={imageSrc} alt="" loading="eager" />
        <div className={contentStyle}>
          <Flex direction="column" gap="s" className={cardStyle}>
            <Text variant="displayS" bold>
              {title}
            </Text>
            <Text variant="bodyM" color="currentColor75">
              {description}
            </Text>
            {children}
          </Flex>
        </div>
      </Flex>
    </>
  );
};
